<app-layout preset="data">
  <app-layout-title>{{ 'ADMIN.simple_extensions' | translate }}</app-layout-title>

  <app-layout-content>
    <app-list class="main-grid" [reloader]="reloader">
      <app-list-container *app-list-eager-provider="let extension of dataSource">

        <app-list-head>{{ extension.name }}</app-list-head>

        <app-list-body class="body-grid">
          @for (project of extension.projects; track project) {
            <app-project-view [iso]="project.isoCode" [name]="project.name"></app-project-view>
          }
        </app-list-body>

        <app-list-actions>
          <button (click)="openExtensionEditor(extension)" color="primary" mat-icon-button>
            <mat-icon>edit</mat-icon>
          </button>
        </app-list-actions>

      </app-list-container>
    </app-list>
  </app-layout-content>
</app-layout>
